import * as Yup from "yup";

const AlertWarningCreationSchema = Yup.object({
  counterCode: Yup.string().required("Counter code is required"),
  barcode: Yup.string().required("Barcode is required"),
  sku: Yup.string().required("SKU is required"),
  threshold: Yup.number()
    .typeError("Threshold must be a number")
    .min(0, "Threshold cannot be negative")
    .required("Threshold is required"),
});

export default AlertWarningCreationSchema;
